var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutlinedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/error_outlined_small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 5C10.6155 5 9.26216 5.41054 8.11101 6.17971C6.95987 6.94888 6.06266 8.04213 5.53285 9.32122C5.00303 10.6003 4.86441 12.0078 5.13451 13.3656C5.4046 14.7235 6.07129 15.9708 7.05026 16.9497C8.02922 17.9287 9.2765 18.5954 10.6344 18.8655C11.9922 19.1356 13.3997 18.997 14.6788 18.4672C15.9579 17.9373 17.0511 17.0401 17.8203 15.889C18.5895 14.7378 19 13.3845 19 12C19 10.1435 18.2625 8.36301 16.9497 7.05025C15.637 5.7375 13.8565 5 12 5ZM12 17.8333C10.8463 17.8333 9.71846 17.4912 8.75918 16.8502C7.79989 16.2093 7.05222 15.2982 6.61071 14.2323C6.16919 13.1664 6.05368 11.9935 6.27876 10.862C6.50384 9.73042 7.05941 8.69102 7.87521 7.87521C8.69102 7.0594 9.73042 6.50383 10.862 6.27875C11.9935 6.05367 13.1664 6.16919 14.2323 6.6107C15.2982 7.05221 16.2093 7.79989 16.8502 8.75917C17.4912 9.71846 17.8333 10.8463 17.8333 12C17.8333 12.766 17.6825 13.5246 17.3893 14.2323C17.0961 14.9401 16.6665 15.5831 16.1248 16.1248C15.5831 16.6665 14.9401 17.0961 14.2323 17.3893C13.5246 17.6824 12.766 17.8333 12 17.8333Z",
    fill: "#615F67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 13.2075C11.7989 13.2075 11.606 13.1276 11.4638 12.9854C11.3216 12.8431 11.2417 12.6503 11.2417 12.4491V8.94913C11.2417 8.74801 11.3216 8.55512 11.4638 8.41291C11.606 8.27069 11.7989 8.1908 12 8.1908C12.2012 8.1908 12.394 8.27069 12.5363 8.41291C12.6785 8.55512 12.7584 8.74801 12.7584 8.94913V12.4491C12.7584 12.6503 12.6785 12.8431 12.5363 12.9854C12.394 13.1276 12.2012 13.2075 12 13.2075Z",
    fill: "#615F67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9707 15.8033C12.454 15.8033 12.8457 15.4116 12.8457 14.9283C12.8457 14.4451 12.454 14.0533 11.9707 14.0533C11.4875 14.0533 11.0957 14.4451 11.0957 14.9283C11.0957 15.4116 11.4875 15.8033 11.9707 15.8033Z",
    fill: "#615F67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutlinedSmall);
export default __webpack_public_path__ + "static/media/error_outlined_small.0147650c26e464149e7b2e6340bfb590.svg";
export { ForwardRef as ReactComponent };